export default __webpack_public_path__ + "static/media/disent-loader.67d7e528.gif";